export const investmentDocumentFileType = {
    draftTermSheet: "draft_term_sheet",
    finalTermSheet: "final_term_sheet",
    singedInvestorAcknowledgement: "signed_investor_acknowledgement",
}